import React, { Component } from 'react'
import { push } from 'react-router-redux'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import AppStore from '../../../store/AppStore'
import { isEqual } from 'lodash'
import InitPasswordAction from '../../actions/InitPasswordAction'
import { connect } from 'react-redux'
import { aquadbSupport } from '../../../conf/basepath'
import { PATH_HOME } from '../../../home/constants/HomeConstants'

class InitPasswordPanel extends Component {

	constructor(props) {
		super(props)
		this.state = {
			login: '',
			password: '',
			confirmPassword: ''
		}
	}

	onValid = () => {
		if (!this.state.login) {
			this.props.putMessage(i18n.error.login)
		} else if (!this.state.password) {
			this.props.putMessage(i18n.error.password)
		} else if (!this.state.confirmPassword) {
			this.props.putMessage(i18n.error.confirmPassword)
		} else {
			if (!isEqual(this.state.password, this.state.confirmPassword)) {
				this.props.putMessage(i18n.error.samePassword)
			} else {
				AppStore.dispatch(InitPasswordAction.initPassword(this.state))
			}
		}
	}
	onChangeValue = (key, value) => {
		const actualState = Object.assign({}, this.state)
		actualState[key] = value.trim()
		this.setState(actualState)
	}


	disableCopyPaste = (event) => {
		event.preventDefault()
	}

	getContactPanel = () => {
		if (this.props.error) {
			return (
				<div className='row no-margin center-align padding-top-10'>
					<div className='col s12'>
						<a className={ 'accountActivationContactUs' } href={ aquadbSupport }
						   target={ '_blank' }> { i18n.needHelp }</a>
					</div>
				</div>
			)
		}
		return null
	}

	render() {
		return (
			<div>
				<div className='card no-margin z-depth-1 radius10'>
					<div className='card-content no-padding row no-margin cardLogin'>
						<form>
							<div className='row no-margin'>
								<div className='input-field col s12 center'>
									<img src='https://www.aquasys.fr/wp-content/uploads/2017/10/AquaDB-grand.png'
										 alt='logo AquaDB'
										 width='70px' className='z-depth-1'/>
								</div>
							</div>
							<div className={ 'row no-margin' }>
								<div className='col s12'>
									<label htmlFor='login' className='valign-wrapper black-text'>
										<i className='material-icons'>person</i>
										{ i18n.login }
									</label>
								</div>
								<div className='col s12'>
									<input ref='login' id='login' type='text' className='validate' required
										   value={ this.state.login }
										   onChange={ (e) => this.onChangeValue('login', e.target.value) }/>
								</div>
							</div>
							<div className={ 'row no-margin' }>
								<div className='col s12'>
									<label htmlFor='password' className='valign-wrapper black-text'>
										<i className='material-icons'>lock_outline</i>
										{ i18n.password }
									</label>
								</div>
								<div className='col s12'>
									<input ref='password' id='password' type='password' className='validate' required
										   value={ this.state.password }
										   onChange={ (e) => this.onChangeValue('password', e.target.value) }/>
								</div>
							</div>
							<div className={ 'row no-margin' }>
								<div className='col s12'>
									<label htmlFor='confirmPassword' className='valign-wrapper black-text'>
										<i className='material-icons'>lock_outline</i>
										{ i18n.confirmPassword }
									</label>
								</div>
								<div className='col s12'>
									<input ref='confirmPassword' id='confirmPassword' type='password'
										   className='validate'
										   value={ this.state.confirmPassword }
										   onCopy={ (e) => this.disableCopyPaste(e) }
										   onPaste={ (e) => this.disableCopyPaste(e) }
										   onChange={ (e) => this.onChangeValue('confirmPassword', e.target.value) }
										   required/>
								</div>
							</div>
							<div className={ 'row no-margin' }>
								<div className='col s10 offset-s1'>
									<script src='https://www.google.com/recaptcha/enterprise.js?render=6LcTYUgfAAAAAA9q3nt1a0dqplRNZOXX7Z5oVcfy' />

								</div>
							</div>
						</form>
						<div className='col l12 m10 s10 offset-m1 offset-s1 padding-bottom-10  '>
							<button onClick={ () => this.onValid() }
									className='waves-effect col l12 m12 s12 waves-light btn'>{ i18n.validate }</button>
						</div>
						<div className='col l12 m10 s10 offset-m1 offset-s1 padding-bottom-10 center-align  '>
							<a onClick={ () => AppStore.dispatch(push(PATH_HOME)) }>{ i18n.alreadyRegistered }</a>
						</div>
					</div>
				</div>
				<div>
					{ this.getContactPanel() }
				</div>
			</div>
		)
	}
}

InitPasswordPanel.propTypes = {
	putMessage: PropTypes.func,
	error: PropTypes.bool
}

const mapStateToProps = (props) => {
	return {
		error: props.InitPasswordReducer.error
	}
}
export default connect(mapStateToProps)(InitPasswordPanel)



// WEBPACK FOOTER //
// ./src/initPassword/components/form/InitPasswordPanel.js